import axios from 'axios'
// import Vue from 'vue'

export function uploadFile({
  file,
  md5,
  spaceId,
  mediaClassId,
  width,
  height,
  widthLimit,
  heightLimit,
}) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('md5', md5)
  formData.append('spaceId', spaceId)
  formData.append('mediaClassId', mediaClassId)
  if (width) {
    formData.append('width', width)
  }
  if (height) {
    formData.append('height', height)
  }
  if (widthLimit) {
    formData.append('widthLimit', widthLimit)
  }
  if (heightLimit) {
    formData.append('heightLimit', heightLimit)
  }
  return axios({
    method: 'post',
    url: 'api/dsp/mediaNew/uploadMedia',
    timeout: 60 * 15 * 1000,
    data: formData,
  })
    .then(({ data }) => {
      return data
    })
    .catch((e) => {
      if (!e.response) {
        const error = {
          message: '请求超时'
        }
        throw error
      } else {
        throw e
      }
    })
}

// 上传接口（背景图、视频、贴图）
export function videoProduceUpload(params) {
  const formData = new FormData()
  formData.append('file', params.file)
  formData.append('md5', params.md5)
  formData.append('resourceType', params.resourceType)
  formData.append('spaceId', params.spaceId)
  return axios({
    method: 'post',
    url: 'api/dsp/videoProduce/upload',
    data: formData
  })
    .then(({ data }) => {
      return data
    })
    .catch((e) => {
      if (!e.response) {
        const error = {
          message: '请求超时'
        }
        throw error
      } else {
        throw e
      }
    })
}

export function materialPackageUpload({
  file,
  md5,
  spaceId,
  resourceType,
  positionCode,
  width,
  height,

}) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('md5', md5)
  formData.append('spaceId', spaceId)
  formData.append('resourceType', resourceType)
  formData.append('positionCode', positionCode)
  width && formData.append('width', width)
  height && formData.append('height', height)
  return axios({
    method: 'post',
    url: 'api/dsp/adMaterialFileUpload/upload',
    timeout: 60 * 15 * 1000,
    data: formData,
  })
    .then(({ data }) => {
      return data
    })
    .catch((e) => {
      if (!e.response) {
        const error = {
          message: '请求超时'
        }
        throw error
      } else {
        throw e
      }
    })
}

export function landingPageUpload({
  file,
  md5,
  landingPageClassId,
}) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('md5', md5)
  formData.append('landingPageClassId', landingPageClassId)
  return axios({
    method: 'post',
    url: 'api/dsp/adLandingPage/uploadLandingPage',
    timeout: 60 * 15 * 1000,
    data: formData,
  })
    .then(({ data }) => {
      return data
    })
    .catch((e) => {
      if (!e.response) {
        const error = {
          message: '请求超时'
        }
        throw error
      } else {
        throw e
      }
    })
}
